import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.js';

const deriveInitialsFromName = (name: string) => {
  return name
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase())
    .join('')
    .slice(0, 2);
};

// @TODO: Update Styles to match:
// Full: https://www.figma.com/design/6ALpWw9jZ3LCo2dMXJ6qy2/IA-Strategy?node-id=2512-23359&m=dev
// Minimal: https://www.figma.com/design/6ALpWw9jZ3LCo2dMXJ6qy2/IA-Strategy?node-id=2470-53138&m=dev
export const Avatar: React.FC<{
  variant: 'full' | 'minimal';
  name?: string;
  email?: string;
  notificationCount?: number;
}> = ({ variant, name, email, notificationCount }) => {
  if (!name) {
    return <ArkIcon iconName="user-01" />;
  }
  const initials = deriveInitialsFromName(name);
  return (
    <div>
      <div className="relative">
        {initials}
        {notificationCount && (
          <span className="label-sm label-potent flex justify-center items-center aspect-ratio-1 absolute">
            {notificationCount}
          </span>
        )}
      </div>
      {variant === 'full' && (
        <div>
          <p>{name}</p>
          {email && <p>{email}</p>}
        </div>
      )}
    </div>
  );
};
